export default __webpack_public_path__ + "static/media/delete-red-icon.47926f56.svg";